<template>
    <div id="manageClass">
        <div>
            <div class="Secondary">
            <nb-tags></nb-tags>
            </div>
        </div>
        <div class="allBodyDiv">
            <div style="margin-top: 15px">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/manageclass' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path:backUrl }" v-if="$route.query.path==2">成员管理</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$route.query.name}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>

            <el-row class="manageClassBody" :gutter="20">
                <el-col :span="24" class="leftMember">
                    <el-card class="box-card ">
                        <div slot="header" class="clearfix">
                            <i class="blueI" style="left: 10px"></i>
                            <span class="cardHeader">{{$route.query.name}}</span>
                        </div>
                        <div>
                            <el-table
                                    :data="tableData2"
                                    border
                                    stripe
                                    show-header
                                    highlight-current-row
                                    row-class-name="graspTr"
                                    header-row-class-name="graspHeader"
                                    style="width: 100%">
                                <el-table-column
                                        prop="experimentName"
                                        label="实验名称">
                                </el-table-column>
                                <el-table-column label="最新得分">
                                    <template slot-scope="props">
                                      {{props.row.score}}
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="submit"
                                        width="145"
                                        label="提交次数">
                                </el-table-column>
                                <el-table-column
                                  prop="notSubmit"
                                        width="145"
                                        label="未提交次数">
                                </el-table-column>
                                <el-table-column
                                        label="操作">
                                    <template slot-scope="scope">
                                            <el-button
                                                    @click="$router.push({
                                                    path: '/classuserdetails',
                                                    query: {
                                                        plan: $route.query.plan,
                                                        type:scope.row.experimentId,
                                                        userName:$route.query.name,
                                                        examName:scope.row.experimentName,
                                                        url:url2
                                                 }})" class="nbBtn nbBtn2" size="small">查看详情</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
    import{
        getstudentexaminfo
    }from'./../../api/exam_api'
    export default {
        data() {
            return{
                tableData2:[],
                backUrl:'/classmember?plan='+this.$route.query.classId,
                url2:''
            }
        },
        methods:{
        },
        mounted(){
            let str= window.location.href;
            let i=str.indexOf("?");
            this.url2=str.substring(i,str.length);
            let data={
                classId:this.$route.query.classId,
              userId:this.$route.query.plan,
            };
            getstudentexaminfo(data).then((res)=>{
              if(res.code == 200 || res.code == 0){
                this.tableData2=res.data;
                // this.tableData2.forEach(function(index,i){
                //   index.add_time=this.GLOBAL.request.toTime(index.add_time * 1000,1);
                // });
              }
            });
        }
    }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/assets/js/pages/exam/MemberDetails.vue